import type { CookieManager } from '@app/services/CookieManager'

import { createThunk } from '@app/store/thunk'

export function getCookies() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<CookieManager>(CookiesSymbol))
}
export function setCookies(value: CookieManager) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(CookiesSymbol, value))
}

const CookiesSymbol = Symbol('Cookies')
